<template>
  <!-- Mobile -->

  <div v-if="isViewportMobile() && headerAction && secondaryHeaderAction">
    <div class="dropdown">
      <button
        class="btn btn-primary cirx-subheader-btn dropdown-toggle cirx-custom-primary-color-btn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-test="actions-btn"
      >
        {{ translate("SHARED.ACTIONS") }}
      </button>

      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item cursor-pointer" @click="headerAction.action">{{ headerAction.title }} </a>
        <a class="dropdown-item cursor-pointer" @click="secondaryHeaderAction.action"
          >{{ secondaryHeaderAction.title }}
        </a>
      </div>
    </div>
  </div>

  <!-- Desktop -->

  <div v-else>
    <!-- First Header Button -->

    <div v-if="isHeaderButtonLoading">
      <div class="spinner-border spinner-border-sm" role="status" />
      {{ translate("SHARED.SIMPLE_LOADING") }}
    </div>

    <template v-else>
      <!-- With only one action -->

      <button
        v-if="headerAction"
        class="btn btn-primary cirx-nav-button cirx-subheader-btn cirx-custom-primary-color-btn"
        @click="headerAction.action"
      >
        {{ headerAction.title }}
      </button>

      <!-- With multiple buyback header actions -->

      <div v-else-if="isAnyBuybackActionActive" :class="{ 'd-block w-100 h-100 mt-15': isViewportMobile() }">
        <div class="dropdown">
          <button
            class="btn btn-primary cirx-subheader-btn dropdown-toggle cirx-custom-primary-color-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-test="actions-btn"
          >
            {{ translate("SHARED.ACTIONS") }}
          </button>

          <div class="dropdown-menu dropdown-menu-right">
            <div v-for="buybackAction in buybackHeaderActions" :key="buybackAction.key">
              <a
                v-if="buybackAction.active"
                :id="buybackAction.key"
                :class="['dropdown-item', 'cursor-pointer', { disabled: buybackAction.loading || buybackAction.error }]"
                data-test="action-item"
                @click="buybackAction.action"
                >{{ buybackAction.title }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Secondary Header Button -->

    <button
      v-if="secondaryHeaderAction"
      class="btn btn-outline-primary cirx-nav-button cirx-subheader-btn cirx-custom-primary-color-btn ml-3"
      @click="secondaryHeaderAction.action"
    >
      {{ secondaryHeaderAction.title }}
    </button>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
// TODO: This should be removed & types should be fixed in https://recommerce.atlassian.net/browse/CXCORE-7893
import useTranslate from "@/core/composables/translate";
import useHeaderButtonStore from "@/core/store/headerButton/headerButtonStore";
import { computed, inject } from "vue";
import { storeToRefs } from "pinia";

/* eslint no-unused-vars:off */
const { translate } = useTranslate();
const { headerButton, secondaryHeaderButton, isAnyBuybackActionActive } = storeToRefs(useHeaderButtonStore());
const headerAction = computed(() => headerButton.value.headerAction);
const secondaryHeaderAction = computed(() => secondaryHeaderButton.value.headerAction);
const buybackHeaderActions = computed(() => headerButton.value.buybackHeaderActions);

const isViewportMobile = inject("isViewportMobile");

const isHeaderButtonLoading = computed(() => headerButton.value.isButtonLoading);
</script>
